import Playlist from './playlist/playlist';
import Video, { CONTAINER_SIZE } from './video';
import PlayStopBtn from './actions/play-stop-btn';
import { rootActions, useAppDispatch, useAppSelector } from '../data/store';
import { useEffect } from 'react';
import { loadMP3List } from '../domain/audio-provider';
import PreloaderScreen from './preloader-screen';
import RadioButtons from './actions/radio-buttons';

const Player = () => {

    const data = useAppSelector(store => store.root.data);
    const selected = useAppSelector(store => store.root.selected);
    const audioContext = useAppSelector(store => store.root.audioContext);
    const isLoading = useAppSelector(store => store.root.isLoading);

    const dispatch = useAppDispatch();

    useEffect(() => {
        (async () => {
            const _data = await loadMP3List(
                data,
                audioContext
            );

            dispatch(
                rootActions.main({
                    isLoading: false,
                    data: _data,
                    selected: (_data && _data.presets?.length > 0) ? _data.presets[0] : null
                })
            )
        })();
    },
        // If we add 'data' here ---> infinite loop.
        // eslint-disable-next-line
        [
            audioContext,
            dispatch,
        ]
    );

    return (
        <div className="bg-gray-150 waves-box-md mx-auto p-4 flex-col lg:flex-row flex relative">
            <Playlist />

            <div className="mx-auto lg:ml-auto max-w-full"
                 style={{
                    width: CONTAINER_SIZE
                 }}
            >
                <Video />

                <div className="flex items-center mt-4">
                    <PlayStopBtn />
                    <RadioButtons />
                    {/*<BypassToggle />
                    <DeltaToggle />*/}
                </div>

                {
                    selected &&
                    <p className="mt-4">
                        { selected.description }
                    </p>
                }
            </div>

            {
                isLoading && <PreloaderScreen />
            }
        </div>
    )
};

export default Player;